/* eslint-disable promise/prefer-await-to-callbacks */

import { Injectable, inject } from '@angular/core'
import { CombinedGraphQLErrors } from '@apollo/client/errors'
import { Subject, catchError } from 'rxjs'
import { DefaultErrorMessages, ErrorMapper } from './error-handles.constant'
import { environment } from '../../../../environments/environment'
import { AlertService } from '../../components/alert/alert.service'
import { LoadingService } from '../root-loading/root-loading.service'
import type { ErrorLink } from '@apollo/client/link/error'
import type { MonoTypeOperatorFunction } from 'rxjs'


@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  public static readonly ERROR_MAPPER = ErrorMapper
  public resetEmitter$ = new Subject<void>()

  private readonly alertService = inject(AlertService)
  private readonly loadingService = inject(LoadingService)

  public handleError({ error }: ErrorLink.ErrorHandlerOptions): void {
    console.error(error)
    console.trace(error)
    this.alertService.error(this.resolveErrorMessage(error))
    this.loadingService.hide()
  }

  public createErrorHandler<T>(): MonoTypeOperatorFunction<T> {
    return catchError((error: unknown) => {
      this.alertService.error(this.resolveErrorMessage(error))
      return []
    })
  }

  private resolveErrorMessage(error: unknown): string {
    if (!error) {
      return DefaultErrorMessages.Default
    }

    if (CombinedGraphQLErrors.is(error)) {
      const message = error.message
      const errorCodes = error.errors.map((graphQLError) => graphQLError.extensions?.['code'])

      return (
        ErrorHandlerService.ERROR_MAPPER[errorCodes[0] as keyof typeof ErrorMapper] ??
        (environment.production
          ? DefaultErrorMessages.Default
          : `Um erro ocorreu: ${message} (${errorCodes[0]})`)
      )
    }

    if (error instanceof Error) {
      return environment.production ? DefaultErrorMessages.Default : `Um erro ocorreu: ${error.message}`
    }

    return DefaultErrorMessages.Network
  }
}
